export default __webpack_public_path__ + "static/media/asistencia-medica.d184c9ef.svg";